__turbopack_context__.v({
  "allCaseStudiesButton": "N90TxW_allCaseStudiesButton",
  "allCaseStudiesButton2": "N90TxW_allCaseStudiesButton2",
  "banner": "N90TxW_banner",
  "bannerContainer": "N90TxW_bannerContainer",
  "bannerLabelProvider": "N90TxW_bannerLabelProvider",
  "bannerVariantProvider": "N90TxW_bannerVariantProvider",
  "buttonWrapper": "N90TxW_buttonWrapper",
  "caseStudies": "N90TxW_caseStudies",
  "desktop": "N90TxW_desktop",
  "freeBox___5ME2": "N90TxW_freeBox___5ME2",
  "freeBox__aqMob": "N90TxW_freeBox__aqMob",
  "freeBox__drdSu": "N90TxW_freeBox__drdSu",
  "freeBox__uFkPq": "N90TxW_freeBox__uFkPq",
  "homeCaseStudiesSectionBanner___1OTky": "N90TxW_homeCaseStudiesSectionBanner___1OTky",
  "homeCaseStudiesSectionBanner___2OdIq": "N90TxW_homeCaseStudiesSectionBanner___2OdIq",
  "homeCaseStudiesSectionBanner__ypcO": "N90TxW_homeCaseStudiesSectionBanner__ypcO",
  "img": "N90TxW_img",
  "left": "N90TxW_left",
  "nav": "N90TxW_nav",
  "navBackButton": "N90TxW_navBackButton",
  "navForwardButton": "N90TxW_navForwardButton",
  "navigationBullet": "N90TxW_navigationBullet",
  "row": "N90TxW_row",
  "sectionHeader": "N90TxW_sectionHeader",
  "sliderCarousel": "N90TxW_sliderCarousel",
  "sliderNavigation": "N90TxW_sliderNavigation",
  "svg___30Xq": "N90TxW_svg___30Xq",
  "svg__daIjG": "N90TxW_svg__daIjG",
  "svg__fouXh": "N90TxW_svg__fouXh",
  "svg__qr8Y": "N90TxW_svg__qr8Y",
  "svg__vcw6E": "N90TxW_svg__vcw6E",
  "svg__wOk2J": "N90TxW_svg__wOk2J",
  "wrapper": "N90TxW_wrapper",
});
